import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {Auth} from "../firebase/auth";

export class SubmenuController {

    /* INSTANCE */
    public static instance: SubmenuController;
    public submenu?: IComponentWindow;

    /* STATIC */
    public static async build(email: string, auth: Auth): Promise<SubmenuController> {
        return SubmenuController.instance = new this(email, auth);
    }

    private constructor(readonly email: string, readonly auth: Auth) {
    }

    private async init(): Promise<void> {
        this.submenu?.buttons?.logout?.addEventListener("click", async () => {
            await this.auth?.logout();
        });
    }

    public async getComponent(): Promise<IComponentWindow> {
        const data = await TemplatesWebFrontendRequest.loginSubmenu(this.email);
        const submenu = new DOMParser().parseFromString(data.data, 'text/html').body.firstChild as HTMLElement;
        this.submenu = {
            window: submenu,
            buttons: {
                logout: submenu.querySelector("#logout-btn-mn") as HTMLElement,
            }
        }
        await this.init();
        if (window.device === "mv") {
            document.getElementsByTagName("body").item(0)?.appendChild(this.submenu.window);
        } else {
            document.querySelector(".usuario-header-login-pos")?.appendChild(this.submenu.window);
        }
        return this.submenu as IComponentWindow;
    }

}
